import React from "react";

/**
 * Iconos estilo Lucide implementados como SVG propios.
 * Se definen manualmente (con los path data de lucide-react) para evitar
 * problemas de compatibilidad de la librería lucide-react con webpack 4 (CRA antiguo).
 * Todos aceptan className, size (px) y color.
 */

const LucideBase = ({ children, className, size = 24, color = "currentColor", ...rest }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...rest}
    >
        {children}
    </svg>
);

// Flujos conversacionales — workflow
export const Workflow = (props) => (
    <LucideBase {...props}>
        <rect width="8" height="8" x="3" y="3" rx="2" />
        <path d="M7 11v4a2 2 0 0 0 2 2h4" />
        <rect width="8" height="8" x="13" y="13" rx="2" />
    </LucideBase>
);

// FAQ — messages-square
export const MessagesSquare = (props) => (
    <LucideBase {...props}>
        <path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5Z" />
        <path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1" />
    </LucideBase>
);

// GenAI — brain
export const Brain = (props) => (
    <LucideBase {...props}>
        <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z" />
        <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z" />
    </LucideBase>
);

// Reporte — bar-chart-3
export const BarChart3 = (props) => (
    <LucideBase {...props}>
        <path d="M3 3v18h18" />
        <path d="M18 17V9" />
        <path d="M13 17V5" />
        <path d="M8 17v-3" />
    </LucideBase>
);

// Campañas — message-circle
export const MessageCircle = (props) => (
    <LucideBase {...props}>
        <path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z" />
    </LucideBase>
);

// Tickets — ticket
export const Ticket = (props) => (
    <LucideBase {...props}>
        <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
        <path d="M13 5v2" />
        <path d="M13 17v2" />
        <path d="M13 11v2" />
    </LucideBase>
);

// Contactos — notebook-tabs
export const NotebookTabs = (props) => (
    <LucideBase {...props}>
        <path d="M2 6h4" />
        <path d="M2 10h4" />
        <path d="M2 14h4" />
        <path d="M2 18h4" />
        <rect width="16" height="20" x="4" y="2" rx="2" />
        <path d="M15 2v20" />
        <path d="M15 7h5" />
        <path d="M15 12h5" />
        <path d="M15 17h5" />
    </LucideBase>
);

// Usuario — user-cog
export const UserCog = (props) => (
    <LucideBase {...props}>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <circle cx="19" cy="11" r="2" />
        <path d="M19 8v1" />
        <path d="M19 13v1" />
        <path d="m21.6 9.5-.87.5" />
        <path d="m17.27 12-.87.5" />
        <path d="m21.6 12.5-.87-.5" />
        <path d="m17.27 10-.87-.5" />
    </LucideBase>
);
